import { render, staticRenderFns } from "./rel-receita-ceagesp.vue?vue&type=template&id=bacbff94&scoped=true&"
import script from "./rel-receita-ceagesp.vue?vue&type=script&lang=js&"
export * from "./rel-receita-ceagesp.vue?vue&type=script&lang=js&"
import style0 from "./rel-receita-ceagesp.vue?vue&type=style&index=0&id=bacbff94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacbff94",
  null
  
)

export default component.exports